import { API } from '.';
import { API_ENDPOINTS } from './api-endpoints.constant';
export async function getToplyneScore(userId) {
    const response = await API.get(`${API_ENDPOINTS.GET_TOPLYNE_SCORE}?user_id=${userId}`);
    const { data } = response;
    return data;
}
export async function getUserLocation() {
    const response = await API.get(API_ENDPOINTS.USER_LOCATION);
    const { data } = response;
    return data;
}
